import React from "react";
import {
  Input,
  Text,
  TextInput,
  Select,
  Button,
  Tooltip,
  Loader,
  Modal,
  LoadingOverlay,
} from "@mantine/core";
export default function TermsOfService({ setOpenedTermsOfService }) {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ width: "90%", padding: 20, margin: 20 }}>
        <Text size="lg" weight="bold" mt="lg">
          Agreement
        </Text>
        <Text size="sm" mt="sm">
          between
        </Text>
        <Text size="sm" mt="sm">
          (1) Adly AB, reg. no. 559282-8239, Teknikringen 7, 583 30, Linköping
          Sweden (The "Company")
        </Text>
        <Text size="sm" mt="sm">
          And
        </Text>
        <Text size="sm" mt="sm">
          (2) The party applying to join the Adly platform (The "Streamer")
        </Text>
        <Text size="sm" mt="sm">
          The Agency and the Streamer are each referred to as a “Party” and
          jointly as the “Parties”.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          General Remarks
        </Text>
        <Text size="sm">
          These Terms and Conditions govern the Streamer’s participation in
          and/or use of certain services or features provided by the Company. By
          submitting the registration form on the Adly Streamer Platform
          (hereinafter referred as the: “Platform”), the Streamer agrees to be
          bound by these terms of service as well as the Privacy Policy and Data
          Processing Agreement.
        </Text>
        <Text size="sm">
          Cooperation with the Company AB does not mean the establishment of a
          new company, partnership or another joint venture. The Parties are
          independent partners, and each of them undertakes to respect the
          economic independence of the other Party.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Duties of the Streamer
        </Text>
        <Text size="sm">
          The Streamer agrees to represent the Agency and its partner
          stakeholders in the capacity of the social media representative
          engaging the global social media community at large, driving customer
          engagement and acquisition through social channels.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer agrees to perform the Services as defined and specified
          for each sponsorship as well as any other services which the Parties
          agree separately upon. Such other services shall be subject to the
          terms and conditions of this Agreement unless otherwise agreed.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer ensures that they are at least 18 years old, and have the
          full capacity to perform acts in law.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer shall not permit any third party to use or gain acceess
          to the Platform. The Streamer shall not access or attempt to access
          the Platform by any other means than through the Website.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer using the Platform are prohibited from any acts and
          threats of violence, as well as hateful conduct and harassment.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer shall not attempt to obstruct, disrupt or interfere with
          the operation of the Platfrom or any other services provided by the
          Company.
        </Text>
        <Text size="sm" mt="sm">
          In case of artificially inflating campaign deliverables (views or
          clicks), using automation software, click spamming, bots, and/or any
          form of fraudulent or suspicious activity implemented by the
          Contractor, the Company reserves the right to finish the cooperation
          immediately, withhold any receivables and also may claim compensation
          for the damage.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer shall pay all applicable sales, use, transfer or other
          taxes and all duties, whether international, national, state or local,
          however, designated, which are levied or imposed by reason of the
          transaction contemplated hereby, excluding, however, income taxes on
          profits which may be levied against the Company. The Streamer shall
          reimburse the Company for the amount of any such taxes or duties paid
          or accrued directly by the Company as a result of the Parties’
          cooperation.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Use of the Services
        </Text>
        <Text size="sm">
          In order to start using the Company's services, the Streamer has to
          provide accurate and complete registration information and give their
          consent to the content of these Terms and to processing of their
          personal data with regard to providing services by the Company.
        </Text>
        <Text size="sm" mt="sm">
          the Company shall not access the Streamer's account for purposes other
          than administrative or support.
        </Text>
        <Text size="sm" mt="sm">
          the Company has the right to accept or reject the Streamer's
          registration to the Platform.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Payments
        </Text>
        <Text size="sm">
          Payments for the Streamer will be calculated per view or otherwise
          determined by the Parties in relation to the specific marketing
          campaign, based on the brief. A total number of views reached during a
          single ad session shall be cumulated and calculated at CPV (cost per
          view) or CPM (cost per mille) at the rate determined by the Parties.
          the Company defines views as the count of viewers during the
          Streamer’s live stream on every ad session.
        </Text>
        <Text size="sm" mt="sm">
          Payments for the Streamer will be calculated per view or otherwise
          determined by the Parties in relation to the specific marketing
          campaign, based on the brief. A total number of views reached during a
          single ad session shall be cumulated and calculated at CPV (cost per
          view) or CPM (cost per mille) at the rate determined by the Parties.
          the Company defines views as the count of viewers during the
          Streamer’s live stream on every ad session.
        </Text>
        <Text size="sm" mt="sm">
          Invoices may be submitted by the Streamer to the Company whenever the
          total of progress payment is €25 including VAT or higher, in TL less
          (a) billing and payment costs (which may include monthly and
          per-transaction processing charges and merchant bank fees); and (b)
          returns, refunds, chargebacks, discounts and credits. the Company will
          make a payment via a bank transfer.
        </Text>
        <Text size="sm" mt="sm">
          the Company will not be obligated to make a payment if the total
          amount to be paid to you under this Agreement is less than €25
          including VAT (the “Payment Threshold”), and may instead accrue such
          payment obligation until such time as its overall obligation to you is
          at least the Payment Threshold. If any excess payment has been made to
          you for any reason whatsoever, we reserve the right to adjust or
          offset the same against any subsequent fees payable to you under this
          Agreement.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer shall be responsible for all income tax liabilities or
          similar contributions relating to the payments made by the Company and
          the Streamer shall indemnify the Company in respect of any such
          payments required to be made by the Company.The Streamer shall not be
          reimbursed for any close expenses incurred in connection with
          respecting these Terms.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Complaints
        </Text>
        <Text size="sm">
          The right to submit a complaint referred to in this point is entitled
          to the Streamer only and exclusively within the scope of the Company's
          services, for which the Company is solely responsible. Email address:
          hampusforsling@adly.gg
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Intellecutal Property Rights
        </Text>
        <Text size="sm">
          The Streamer shall not rent, lease, sublicense, distribute, transfer,
          copy, or modify Adly's software.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer shall not adapt Adly's software in any way or use it to
          create a derivative work.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer shall not translate, decompile, or create or attempt to
          create, by reverse engineering or otherwise, the source code of the
          Company's software.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer’s materials and data entered into the Company's software
          are and shall remain their sole and exclusive property, including all
          applicable rights to patents, copyrights, trademarks, trade secrets,
          or other proprietary or intellectual property rights inherent therein
          or appurtenant thereto.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Confidentiality
        </Text>
        <Text size="sm">
          The Contractor agrees that the Platform and the Company’s software are
          the Company’s confidential and/or trade secret information
          (collectively, “Confidential Information”). The Streamer shall not
          sell, transfer, publish, disclose, display, or otherwise make
          available any portion of the Confidential Information to others except
          as expressly provided for herein. The Streamer agrees to secure and
          protect the Confidential Information in a manner consistent with the
          maintenance of the Company's rights therein. The Streamer shall use
          its best efforts to assist the Company in identifying and preventing
          any unauthorized access, use, copying, or disclosure of the
          Confidential Information, or any component thereof, or any of the
          algorithms or logic contained therein.
        </Text>
        <Text size="sm" mt="sm">
          The Streamer acknowledges that the disclosure of any aspect of the
          Confidential Information, including without limitation the Company or
          any other Confidential Information referred to herein, or any
          information which, at law or equity ought to remain confidential, will
          immediately give rise to continuing irreparable injury to the Company
          inadequately compensable in damages at law, and the Company is
          entitled to seek and obtain immediate injunctive relief against the
          breach or threatened breach of any of the foregoing confidentiality
          undertakings, in addition to any other legal remedies which may be
          available. In addition, the Company may immediately terminate these
          Terms, the Streamer’s account and all license rights granted herein,
          in the event the Streamer breaches any of its confidentiality
          obligations.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Term & Termination
        </Text>
        <Text size="sm">
          The date of these Terms and Conditions shall begin on the date of the
          acceptance of the Streamer’s registration form and creation of the
          Streamer’s account by Adly and will remain in full force and effect
          for an indefinite period. However, these Terms may be terminated by
          each Party with a month notice period in writing. Regardless of the
          circumstances, such termination shall not give rise to liability.
        </Text>
        <Text size="sm" mt="sm">
          This Agreement can be terminated at any time by either Party with
          immediate effect upon giving the other Party written notice. in case
          of material breach of this Agreement by the other Party which is
          incapable of remedy or which, if capable of remedy, has not been
          remedied within 15 working days of service of a written notice from
          the non-defaulting Party specifying the breach and requiring it to be
          remedied.
        </Text>
        <Text size="sm" mt="sm">
          The Company may also suspend the Streamer's access to the Company’s
          software at any time, without advance notice, for any reason that The
          Company finds valid at its sole discretion, including but not limited
          to where The Company believes that: (1) the Streamer is in any way in
          breach of the terms; (2) the Streamer, at any time, is conducting
          activities that do not fully comply with all applicable laws, rules
          and regulations; (3) Provisions of these Terms that due to their
          nature will continue to be in force after the termination of these
          Terms and Conditions.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Disclaimer of Warranties And Limitation of Liability
        </Text>
        <Text size="sm">
          The Company and its respective officiers, directors, shareholders,
          members, employees, advisors, contractors, licensors, licensees,
          suppliers, vendors, users and agents are not responsible for any
          content provided by third parties (including contractors). Except as
          expressly set forth herein, none of the Company's parties make any
          respresentation or warranty of any kind, whether express, implied,
          statutory or otherwise, including without limitation warranties of
          merchantability, fitness for a particular use, non-infringement and
          any implied warranties arising from course of dealing or course of
          performance. The entire risk arising out of the use of the Company
          remains with the Streamer. Without limiting the generality of the
          foregoing, the Company parties specifically disclaim any
          representation or warranty regarding: (1) Meeting the Streamer's
          requirements while using Adly's services, (2) Timely, the error-free,
          disruption-free or interrpuration-free nature of the Company's
          software and (3) accurate usage of data provided through the Company's
          services.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Governing Law And Jurisdiction
        </Text>
        <Text size="sm">
          This Agreement shall be governed and interpreted in accordance with
          Swedish law.
        </Text>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            mt="lg"
            onClick={() => {
              setOpenedTermsOfService(false);
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
